import React, { useEffect, useState } from "react";
import ExperientialBody from "./ExperientialBody";
import BottomInput from "./BottomInput";
import Assistant from "../ai-tutor/Assistant/Assistant";
import { useLocation, useNavigate } from "@remix-run/react";
import { Box } from "@chakra-ui/react";
import styles from "./experiential.module.css";
import useStateRef from "react-usestateref";
import { getEmotionalMessageText, isNotEmptyOrNull } from "../../../utils/common-utils";
import { StorageService } from "../../../utils/StorageUtils";
import wall_images from "../../../utils/wall/wall-imges";
import Lottie from "react-lottie-player";
import { ExperientialComponentStyles } from "./experientialComponentStyles";
import { getPostById } from "../../../api/wall";

export default function ExperientialComponent({ expData }) {
  const [isBackClicked, setIsBackClicked] = useState(false);
  const [isBackClickedPost, setIsBackClickedPost] = useState(false); // this is for the key to send to backend
  const [userDescription, setUserDescription] = useState("");
  const [postItem, setPostItem, postItemRef] = useStateRef({});
  const [isEdit, setIsEdit] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [userDetails, setUserDetails, userDetailsRef] = useStateRef({});
  const [messageText, setMessageText] = useState("");
  const location = useLocation();
  const { experientialLearningData, postId, selectedItem } =
  location.state || " ";
  const navigate = useNavigate();

  const goBack = (userDescription, postItem) => {
    setUserDescription(userDescription);
    setPostItem(postItem);
    setIsEdit(false);
    setIsBackClicked(true);
    setIsBackClickedPost(true);
  };

  const editPost = () => {
    setIsBackClicked(false);
    setIsEdit(true);
  };

  const deletePost = () => {
    setPostItem({});
    setIsBackClicked(false);
    setIsEdit(true);
    setIsDelete(true);
  };

  const getMessageText = async () => {
    let text = await getEmotionalMessageText(20);

    // Replace placeholder with student's name if present
    if (text.includes("@@studentName") || text.includes("@@studentname")) {
      text = text.replace(
        /@@studentName|@@studentname/g,
        `${userDetailsRef.current?.firstName}`
      );
    }

    if (text.includes("@@linebreak")) {
      text = text.replace(/@@linebreak/g, `\n`);
    }

    if (text.includes("@@experientialactivitytitle")) {
      text = text.replace(
        "@@experientialactivitytitle",
        `${experientialLearningData?.activityInfo?.name}`
      );
    }

    if (text.includes("@@topicname")) {
      text = text.replace(
        "@@topicname",
        `${selectedItem?.taskAttributes?.topicName}`
      );
    }

    setMessageText(text);
  };

  useEffect(() => {
    let details = StorageService.getItem("user_additional_details");
    details = typeof details === "object" ? details : JSON.parse(details);
    if (details) {
      setUserDetails(details);
    }
    getMessageText();
  }, []);

  console.log("postId", postId);

  useEffect(() => {
    const fetchPost = async () => {
      let response = await getPostById(postId);
      console.log("response", response?.data?.data[0]);
      setPostItem(response?.data?.data[0]);
    };
    fetchPost();
  }, [postId]);

  useEffect(() => {
    if (!isNotEmptyOrNull(experientialLearningData)) {
      navigate(-1);
    }
  }, [experientialLearningData, navigate]);

  return (
    <Box sx={ExperientialComponentStyles()?.mainContainer}>
      {/* <Box sx={ExperientialComponentStyles()?.lottieVin}>
         <Lottie
           animationData={wall_images.experientialWelcome}
           play
           loop={false}
         />
        </Box> */}
      <Box sx={ExperientialComponentStyles()?.subContainer}>
        <Box sx={ExperientialComponentStyles()?.topContainer}>
          <Box sx={ExperientialComponentStyles()?.emotionalScriptRow}>
            <Box sx={ExperientialComponentStyles()?.lottieVinVariant}>
              <Lottie
                animationData={wall_images.experientialWelcome}
                play
                loop={false} />

            </Box>
            <Assistant
              hideVin={true}
              text={messageText}
              isEmotionalScript={true} />

          </Box>
          <Box sx={ExperientialComponentStyles()?.experientialBody}>
            <ExperientialBody
              expData={experientialLearningData}
              isBackClicked={isBackClicked}
              userDescription={userDescription}
              postItem={postItemRef?.current}
              handleEdit={editPost}
              handleDeleteCallback={deletePost} />

          </Box>
        </Box>
      </Box>
      <Box sx={ExperientialComponentStyles()?.bottomInput}>
        <Box sx={ExperientialComponentStyles()?.bottomEditor}>
          <BottomInput
            expData={experientialLearningData}
            goBack={goBack}
            isEdit={isEdit}
            isBackClicked={isBackClicked}
            isDelete={isDelete}
            postId={postId}
            isBackClickedPost={isBackClickedPost} />

        </Box>
        <Box sx={ExperientialComponentStyles()?.bottomBox} />
      </Box>
    </Box>);

}